export const environment = {
  production: true,
  //wsdlUrl: "https://divlec.com/api/",
  //wsdlUrl: "https://demomp.utuapps.com/api/",
  //wsdlUrl: "https://utushop.utuapps.com/api/",
  configUrl: "/assets/config/config.json",
  wsdlUrl: "https://myl.utuapps.com/api/",


};
